import { fileDownload } from 'utils/fileDownload';
import { logError } from 'utils/sentryUtils';

import { mmFetch } from './mmFetch';
import { mmFetchWithResponse } from './mmFetchWithResponse';

const goPuffApi = {
    bulkDownloadBOLs: async (facilityID, lineHaulName, deliveryDate) => {
        const url = `api/partnerships/v1/goPuff/orders/bulkOrderBOLs?facilityID=${facilityID}&lineHaul=${lineHaulName}&deliveryDate=${deliveryDate}`;

        const respObj = {
            status: true,
            data: {},
            msg: '',
        };

        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                if (res.headers.get('Content-Type')?.includes('application/json')) {
                    respObj.status = false;
                    respObj.msg = 'Unexpected JSON response';
                } else {
                    await fileDownload(res, `bulk_BOLS_${lineHaulName}_${deliveryDate}_.html`);
                }
            } else {
                const decodedResp = await res.json();
                respObj.msg = decodedResp.msg;
                respObj.status = false;
            }
        } catch (e) {
            logError(e);
            respObj.msg = e.toString();
            respObj.status = false;
        }

        return respObj;
    },
    bulkDownloadPackSlips: async (facilityID, lineHaulName, deliveryDate) => {
        const url = `api/partnerships/v1/goPuff/orders/bulkOrderPackSlips?facilityID=${facilityID}&lineHaul=${lineHaulName}&deliveryDate=${deliveryDate}`;

        const respObj = {
            status: true,
            data: {},
            msg: '',
        };

        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                if (res.headers.get('Content-Type')?.includes('application/json')) {
                    respObj.status = false;
                    respObj.msg = 'Unexpected JSON response';
                } else {
                    await fileDownload(res, `bulk_packslips_${lineHaulName}_${deliveryDate}_.pdf`);
                }
            } else {
                const decodedResp = await res.json();
                respObj.msg = decodedResp.msg;
                respObj.status = false;
            }
        } catch (e) {
            logError(e);
            respObj.msg = e.toString();
            respObj.status = false;
        }

        return respObj;
    },
    confirmAllocationUpload: async (key) => {
        const url = 'api/partnerships/v1/goPuff/allocation/bulk';
        const response = await mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ key }),
        });
        return response;
    },
    confirmOrderUpload: async (key) => {
        const url = 'api/partnerships/v1/goPuff/orders/bulk';
        const response = await mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ key }),
        });
        return response;
    },
    confirmPricingUpload: async (key) => {
        const url = 'api/partnerships/v1/goPuff/pricing/upload';
        const response = await mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ key }),
        });
        return response;
    },
    createMicroFulfillmentCenter: async (item) => {
        const url = `api/partnerships/v1/gopuff/microFC`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(item),
        });
        return response;
    },
    downloadAllocationCsv: async (facilityID, deliveryDate) => {
        const url = `api/partnerships/v1/gopuff/allocation/csv?facilityID=${facilityID}&deliveryDate=${deliveryDate}`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                await fileDownload(res, `goPuffAlloction${facilityID}.csv`);
            }
        } catch (e) {
            logError(e);
        }
    },
    downloadBOL: async (shipmentID) => {
        const url = `api/partnerships/v1/goPuff/orders/bol/${shipmentID}`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                await fileDownload(res, `bol${shipmentID}.html`);
            }
        } catch (e) {
            logError(e);
        }
    },
    downloadInvoiceCsv: async (invoiceID) => {
        const url = `api/partnerships/v1/gopuff/invoices/${invoiceID}/csv`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                await fileDownload(res, `goPuffInvoice${invoiceID}.csv`);
            }
        } catch (e) {
            logError(e);
        }
    },
    downloadPackSlip: async (shipmentID) => {
        const url = `api/partnerships/v1/goPuff/orders/packSlip/${shipmentID}`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                await fileDownload(res, `packslip${shipmentID}.pdf`);
            }
        } catch (e) {
            logError(e);
        }
    },
    getAllocationRollup: async (facilityID) => {
        const url = `api/partnerships/v1/gopuff/allocation/rollup?facilityID=${facilityID}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getLineHaulsWithOrders: async (facilityID) => {
        const url = `api/partnerships/v1/goPuff/lineHauls?facilityID=${facilityID}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getMicroFulfillmentCenters: async () => {
        const url = `api/partnerships/v1/gopuff/microFC`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getInvoices: async (startDate, endDate, facilityID) => {
        const url = `api/partnerships/v1/gopuff/invoices?startDate=${startDate}&endDate=${endDate}&facilityID=${facilityID}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getOrders: async (facilityID) => {
        const url = `api/partnerships/v1/goPuff/orders?facilityID=${facilityID}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getOrdersByLineHauls: async (facilityID, lineHaul, deliveryDate = null) => {
        const url = `api/partnerships/v1/goPuff/ordersByLineHaul?facilityID=${facilityID}&lineHaul=${lineHaul}&deliveryDate=${deliveryDate}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getOrdersWithinRange: async (facilityID, startDate, endDate) => {
        const url = `api/partnerships/v1/goPuff/orders?facilityID=${facilityID}&startDate=${startDate}&endDate=${endDate}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getPOCredits: async (startDate, endDate) => {
        const url = `api/partnerships/v1/goPuff/purchaseOrderCredit?startDate=${startDate}&endDate=${endDate}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getPurchaseOrderCreditReasons: async () => {
        const url = `api/partnerships/v1/goPuff/purchaseOrderCredit/reasons`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getPurchaseOrderDetails: async (poNum) => {
        const url = `api/partnerships/v1/goPuff/purchaseOrders/${poNum}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getPricing: async () => {
        const url = `api/partnerships/v1/goPuff/pricing`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getPackoutRows: async (facilityID) => {
        const url = `api/partnerships/v1/gopuff/packout?facilityID=${facilityID}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getPrintableBatches: async (facilityID) => {
        const url = `api/partnerships/v1/gopuff/batches/printable?facilityID=${facilityID}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getPrintableBatchesDetails: async (key, value, deliveryDate) => {
        const url = `api/partnerships/v1/gopuff/batches/printable/details?${key}=${value}&deliveryDate=${deliveryDate}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getPrintedBatches: async (facilityID) => {
        const url = `api/partnerships/v1/gopuff/batches/printed?facilityID=${facilityID}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getShipmentDetails: async (shipmentID) => {
        const url = `api/partnerships/v1/goPuff/orders/details/${shipmentID}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getTMSPalletUploads: async () => {
        const url = `api/partnerships/v1/goPuff/tms-uploads`;
        return mmFetchWithResponse(url);
    },
    uploadTMSPalletData: async (data) => {
        const formData = new FormData();
        formData.append('tmsFile', data.file);

        const url = 'api/partnerships/v1/goPuff/tms-uploads/cache';
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
    },
    confirmTMSPalletUpload: async (key) => {
        const url = 'api/partnerships/v1/goPuff/tms-uploads/confirm';
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ key }),
        });
    },
    markTMSPalletUploadWithStatus: async (id, sendParams) => {
        const url = `api/partnerships/v1/goPuff/tms-uploads/mark-pallets/${id}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(sendParams),
        });
    },
    updateTMSPalletData: async (id, item) => {
        const url = `api/partnerships/v1/goPuff/tms-uploads/update-pallet/${id}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(item),
        });
    },
    downloadTMSPalletDataCsv: async () => {
        const url = `api/partnerships/v1/goPuff/tms-uploads/download-csv`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                await fileDownload(res, `tms_pallet_data.csv`);
                return { status: true };
            }
            return { status: false };
        } catch (e) {
            logError(e);
            return { status: false };
        }
    },
    issuePOCredit: async (items) => {
        const url = `api/partnerships/v1/goPuff/purchaseOrderCredit`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(items),
        });
        return response;
    },
    markDelivered: async (sendParams) => {
        const url = `api/partnerships/v1/goPuff/orders/delivered`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(sendParams),
        });
        return response;
    },
    printBatch: async (facilityID, key, value, deliveryDate) => {
        const url = `api/partnerships/v1/gopuff/batches/print?facilityID=${facilityID}&${key}=${value}&deliveryDate=${deliveryDate}`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                await fileDownload(res, 'gopuffbatch.pdf');
            }
        } catch (e) {
            logError(e);
        }
    },
    reprintBatch: async (batchID) => {
        const url = `api/partnerships/v1/gopuff/batches/reprint?batchID=${batchID}`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                await fileDownload(res, 'gopuffbatch.pdf');
            }
        } catch (e) {
            logError(e);
        }
    },
    sendInvoice: async (id) => {
        const url = `api/partnerships/v1/gopuff/invoices`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ id }),
        });
        return response;
    },
    sendPackoutFile: async (facilityID, packedDate) => {
        const url = `api/partnerships/v1/gopuff/sendPackoutFile?facilityID=${facilityID}&packedDate=${packedDate}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    updateMicroFulfillmentCenter: async (id, item) => {
        const url = `api/partnerships/v1/gopuff/microFC/${id}`;
        const response = await mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(item),
        });
        return response;
    },
    uploadAllocation: async (data, facilityID) => {
        const formData = new FormData();
        formData.append('allocationFile', data.file);

        const url = `api/partnerships/v1/goPuff/allocation/bulk?facilityID=${facilityID}`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
        return response;
    },
    uploadOrders: async (data) => {
        const formData = new FormData();
        formData.append('orderFile', data.file);

        const url = 'api/partnerships/v1/goPuff/orders/bulk';
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
        return response;
    },
    uploadPricing: async (data) => {
        const formData = new FormData();
        formData.append('pricingFile', data.file);

        const url = 'api/partnerships/v1/goPuff/pricing/upload';
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
        return response;
    },
    cancelOrder: async (purchaseOrderName) => {
        const url = `api/partnerships/v1/goPuff/orders/${purchaseOrderName}/cancel`;
        const response = await mmFetchWithResponse(url, {
            method: 'PUT',
        });
        return response;
    },
};

export { goPuffApi };
